import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from './pages/Home';
import LogIn from "./pages/LogIn";
import SignUp from "./pages/SignUp";
import Navbar from './components/common/Navbar';
import ForgotPassword from "./pages/ForgotPassword";
import VerifyEmail from "./pages/VerifyEmail";
import NotFound from "./pages/404";
import CommingSoon from "./pages/CommingSoon";
import { FooterLink1 } from "./data/footer-links";
import { FooterLink2 } from "./data/footer-links";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import UpdatePassword from "./pages/UpdatePassword";
import OpenRoute from "./components/core/Auth/OpenRoute";
import MyProfile from "./components/core/dashboard/MyProfile";
import ProtectedRoute from "./components/core/Auth/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import EnrolledCourses from "./components/core/dashboard/student/EnrolledCourses";
import ProfileSettings from "./components/core/dashboard/settings/ProfileSettings";
import TeachingAnalytics from "./components/core/dashboard/instructor/teachingAnalytics/TeachingAnalytics";
import NewCourse from "./components/core/dashboard/instructor/newCourse/index";
import MyCourses from "./components/core/dashboard/instructor/myCourses/MyCourses";
import Wishlist from "./components/core/dashboard/student/wishlist";
import ProtectedRouteForStudent from "./components/core/Auth/ProtectedRouteForStudents";
import ProtectedRouteForInstructor from "./components/core/Auth/ProtectedRouteForInstructor";
import CategoryPage from "./pages/CategoryPage";
import CoursePage from "./pages/CoursePage";
import ViewCourse from "./pages/ViewCourse";
import VideoView from "./components/core/viewCourse/VideoView";
import CoursesFeed from "./pages/CoursesFeed";
import InstructorPage from "./pages/InstructorPage";
import SecureRouteForAuthorizeStudentAndInstructor from "./components/core/Auth/SecureRouteForAuthorizeStudentAndInstructor";
import { useSelector } from "react-redux";
import Loading from "./pages/Loading.jsx";

function App() {
  const { blurLoading } = useSelector(state => state.auth);
  return (
    <main className="relative w-screen bg-richblack-900 flex overflow-hidden flex-col font-inter">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:categoryName" element={<CategoryPage />} />
        <Route path="/feed" element={<CoursesFeed />} />
        <Route path="/course/:courseName/:courseId" element={<CoursePage />} />
        <Route path="/instructor/:instructorId" element={<InstructorPage />} />
        <Route element={
          <ProtectedRoute>
            <SecureRouteForAuthorizeStudentAndInstructor>
              <ViewCourse />
            </SecureRouteForAuthorizeStudentAndInstructor>
          </ProtectedRoute>
        } >
          <Route
            path="/course/:courseName/:courseId/:sectionId/:subSectionId"
            element={<VideoView />}
          />
        </Route>
        <Route path="/login" element={
          <OpenRoute>
            <LogIn />
          </OpenRoute>
        } />
        <Route path="/signup" element={
          <OpenRoute>
            <SignUp />
          </OpenRoute>
        } />
        <Route path="/forgot-password" element={
          <OpenRoute>
            <ForgotPassword />
          </OpenRoute>
        } />
        <Route path="/reset-password/:token" element={
          <OpenRoute>
            <UpdatePassword />
          </OpenRoute>
        } />
        <Route path="/verify-email" element={
          <OpenRoute>
            <VerifyEmail />
          </OpenRoute>
        } />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } >
          <Route path="/dashboard/profile" element={<MyProfile />} />
          <Route path="/dashboard/settings" element={<ProfileSettings />} />
          <Route path="/dashboard/enrolled-courses" element={
            <ProtectedRouteForStudent>
              <EnrolledCourses />
            </ProtectedRouteForStudent>
          } />
          <Route path="/dashboard/wishlist" element={
            <ProtectedRouteForStudent>
              <Wishlist />
            </ProtectedRouteForStudent>
          } />
          <Route path="/dashboard/teaching-analytics" element={
            <ProtectedRouteForInstructor>
              <TeachingAnalytics />
            </ProtectedRouteForInstructor>
          } />
          <Route path="/dashboard/new-course" element={
            <ProtectedRouteForInstructor>
              <NewCourse />
            </ProtectedRouteForInstructor>
          } />
          <Route path="/dashboard/my-courses" element={
            <ProtectedRouteForInstructor>
              <MyCourses />
            </ProtectedRouteForInstructor>
          } />
        </Route>
        {FooterLink1.map((item) => (item.links.map((link, index) => (
          <Route key={index} path={link.link} element={<CommingSoon />} />
        ))))}
        {FooterLink2.map((item) => (item.links.map((link, index) => (
          <Route key={index} path={link.link} element={
            <CommingSoon
              text="We're fairly sure that the page used to be here, but it seems to have gone missing.
                        We do apologize on its behalf."
            />
          } />
        ))))}
        <Route path="/*" element={<NotFound />} />
      </Routes>
      {blurLoading && <Loading />}
    </main>
  );
}

export default App;